/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetNotificationPrefsRow } from '../openapi-types.gen.js';
import { type useGetNotificationPrefsArgs, useGetNotificationPrefsSpec } from '../specs/users.spec.gen.js';

export type { GetNotificationPrefsRow } from '../openapi-types.gen.js';
export type { useGetNotificationPrefsArgs } from '../specs/users.spec.gen.js';


export const useGetNotificationPrefs = createHook(useGetNotificationPrefsSpec);


/**
 * Hover/intent prefetch companion for `useGetNotificationPrefs`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetNotificationPrefs();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetNotificationPrefs = createPrefetchHook(useGetNotificationPrefsSpec);
